import { HeroIntro as UniformHeroIntro } from "./hero-intro";
export type { HeroIntroProps } from "./hero-intro";

export default UniformHeroIntro;
